export default function ({store}) {
  store.dispatch('settings/fetchSettings')
}
